import { render, staticRenderFns } from "./Manage-Remark.vue?vue&type=template&id=536a48e4"
import script from "./Manage-Remark.vue?vue&type=script&lang=js"
export * from "./Manage-Remark.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports